import { render, staticRenderFns } from "./HeroesModal.vue?vue&type=template&id=c50cf40a&scoped=true&"
import script from "./HeroesModal.vue?vue&type=script&lang=js&"
export * from "./HeroesModal.vue?vue&type=script&lang=js&"
import style0 from "./HeroesModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HeroesModal.vue?vue&type=style&index=1&id=c50cf40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50cf40a",
  null
  
)

export default component.exports